export class TransportError extends Error {
  public readonly status?: number;
  public readonly retryAfterMs?: number;

  constructor(message: string, options: { status?: number; retryAfterMs?: number } = {}) {
    super(message);
    this.name = 'TransportError';
    this.status = options.status;
    this.retryAfterMs = options.retryAfterMs;
  }
}

/**
 * Returns true when a TransportError status should NOT be retried by the queue.
 * 4xx client errors (other than 408 Request Timeout and 429 Too Many Requests)
 * indicate a request problem that re-sending will not fix.
 */
export function isNonRetriableStatus(status: number | undefined): boolean {
  if (typeof status !== 'number') return false;
  if (status < 400 || status >= 500) return false;
  if (status === 408 || status === 429) return false;
  return true;
}

export function parseRetryAfter(headerValue: string | null | undefined): number | undefined {
  if (!headerValue) return undefined;
  const trimmed = headerValue.trim();
  if (!trimmed) return undefined;
  const numeric = Number(trimmed);
  if (Number.isFinite(numeric) && numeric >= 0) {
    return Math.floor(numeric * 1000);
  }
  const dateMs = Date.parse(trimmed);
  if (Number.isFinite(dateMs)) {
    const diff = dateMs - Date.now();
    return diff > 0 ? diff : 0;
  }
  return undefined;
}
